import { Link } from "@heroui/react";
import MsiBrandLogo from '../../../assets/MSI.svg';
import { FC } from 'react';

const BrandLogo: FC = () => {
	return (
		<Link className='align-middle'  href={window.config.SHELL_APP_URL}>
			<img  src={MsiBrandLogo} className="position-static left-1/2 w-72" alt="Maritime Strategies International" />
		</Link>
	);
};

export default BrandLogo;